import { getCDNImageUrl } from '@/helpers/cdn';

export enum LootboxState {
  CLOSED = 'CLOSED',
  IS_OPENING_EMPTY = 'IS_OPENING_EMPTY',
  IS_OPENING_FULL = 'IS_OPENING_FULL',
  OPENED_FULL = 'OPENED_FULL',
}

export const lootboxAnimationSrc = (state: LootboxState) => {
  switch (state) {
    case LootboxState.IS_OPENING_EMPTY:
      return getCDNImageUrl('/lootbox/isOpeningEmpty.svg');
    case LootboxState.IS_OPENING_FULL:
      return getCDNImageUrl('/lootbox/isOpeningFull.svg');
    case LootboxState.OPENED_FULL:
      return getCDNImageUrl('/lootbox/openedFull.svg');
    case LootboxState.CLOSED:
    default:
      return getCDNImageUrl('/lootbox/closed.svg');
  }
};
